/* eslint-disable no-underscore-dangle */
import SvgIcon from './svg-icon';
import ApiManager from '../api/crud-manager';
import jsonToView from '../api/json-to-view';
// import Incrementer from './incrementer';

/**
 * Class real time product price module
 * @class
 * @author Max Swinkels <max.swinkels@pangaea.nl>
 *
 */

class RealTimePrice {
  constructor(options = {}) {
    this.config = {
      moduleList: () => document.querySelectorAll('[data-module="RealTimePrice"]'),
      moduleListStaffel: () => document.querySelectorAll('[data-module="RealTimePriceStaffel"]'),
      apiManager: new ApiManager(),
      ...options
    };
  }

  // fetch product price based on product id
  async getPrice(productId, quantity = 1) {
    const { apiManager } = this.config;

    const url = `/api/v2/catalog/product/${productId}/prices?quantity=${quantity}`;

    return apiManager.get(url).then(data => ({ ...data, quantity }));
  }

  initRealTimePriceStaffel(_module) {
    const module = _module;

    const {
      productId,
      itemcode,
      hasChildren,
      resourceErrorMessage,
      pricesExTax,
      initialized,
      staffels,
      orderUnit
    } = module.dataset;

    if (!productId && (initialized != null && initialized)) return;

    module.dataset.initialized = true; // skip initialized module items
    module.classList.add('is-loading');

    const splittedStaffels = staffels.split('#');
    // sort splittedStaffels
    splittedStaffels.sort((a, b) => a - b);

    const priceApiCalls = [];
    splittedStaffels.forEach(staffel => {
      priceApiCalls.push(this.getPrice(productId, staffel));
    });

    Promise.all(priceApiCalls)
      .then(responses => {
        const staffelPrices = responses.map((response, index) => {
          let { prices } = response._embedded;
          const { quantity } = response;
          let quantityText = `${quantity} +`;

          if (index < responses.length - 1)
            quantityText = `${quantity} - ${responses[index + 1].quantity - 1}`;

          prices = prices.length ? prices[0] : null;
          return { ...prices, quantity, quantityText, productId, itemcode };
        });

        // filter staffelPrices with currentPrice already on other staffelPrices except the first one
        const filteredStaffelPrices = staffelPrices.filter((staffelPrice, i) => {
          if (i === 0) return true;
          return !staffelPrices.find(
            price =>
              price.quantity !== staffelPrice.quantity &&
              price.currentPrice === staffelPrice.currentPrice
          );
        });

        if (filteredStaffelPrices.length === 1) {
          RealTimePrice.setPriceElement(
            module,
            filteredStaffelPrices,
            hasChildren,
            pricesExTax,
            resourceErrorMessage,
            orderUnit
          );
          document.querySelectorAll('.show-when-one-price').forEach(el_ => {
            const el = el_;
            el.style.display = 'block';
          });
          return;
        }

        RealTimePrice.setStaffelPriceElement(
          module,
          filteredStaffelPrices,
          pricesExTax,
          resourceErrorMessage,
          orderUnit
        );
      })
      .catch(error => {
        module.classList.remove('is-loading');
        module.innerHTML = resourceErrorMessage || 'Price not available';
        throw new Error(error);
      });
  }

  static setPriceElement(
    module_,
    prices,
    hasChildren,
    pricesExTax,
    resourceErrorMessage,
    orderUnit
  ) {
    const module = module_;
    const templateView = 'RealTimePrice';
    const { productEnabled = 'True' } = module.dataset;
    const viewData = {
      price: prices.length ? prices[0] : null,
      hasChildren,
      pricesExTax,
      productEnabled,
      orderUnit
    };
    console.log(templateView);
    console.log(viewData);
    // create view based on template file
    jsonToView(viewData, templateView)
      .then(html => {
        module.classList.remove('is-loading');
        module.innerHTML = html;
      })
      .catch(error => {
        module.classList.remove('is-loading');
        module.innerHTML = resourceErrorMessage || 'Price not available';
        throw new Error(error);
      });
  }

  static setStaffelPriceElement(module_, prices, pricesExTax, resourceErrorMessage, orderUnit) {
    const module = module_;
    const templateView = 'RealTimePriceStaffel';
    const { productEnabled } = module.dataset;
    const viewData = {
      price: prices.length ? prices : null,
      pricesExTax,
      productEnabled,
      orderUnit
    };

    // create view based on template file
    jsonToView(viewData, templateView)
      .then(html => {
        module.classList.remove('is-loading');
        module.innerHTML = html;
        new SvgIcon().init();
        // new Incrementer().init();
      })
      .catch(error => {
        module.classList.remove('is-loading');
        module.innerHTML = resourceErrorMessage || 'Price not available';
        throw new Error(error);
      });
  }

  init() {
    const { moduleList, moduleListStaffel } = this.config;

    moduleList().forEach(_module => {
      const module = _module;

      const {
        productId,
        hasChildren,
        pricesExTax,
        resourceErrorMessage,
        initialized,
        usePriceFrom,
        staffels,
        orderUnit
      } = module.dataset;
      if (!productId && (initialized != null && initialized)) return;

      module.dataset.initialized = true; // skip initialized module items
      module.classList.add('is-loading');

      if (!usePriceFrom) {
        this.getPrice(productId)
          .then(response => {
            // eslint-disable-next-line no-underscore-dangle
            const { prices } = response._embedded;
            const templateView = 'RealTimePrice';
            const viewData = {
              price: prices.length ? prices[0] : null,
              hasChildren,
              pricesExTax
            };

            // create view based on template file
            jsonToView(viewData, templateView)
              .then(html => {
                module.classList.remove('is-loading');
                module.innerHTML = html;
              })
              .catch(error => {
                module.classList.remove('is-loading');
                module.innerHTML = resourceErrorMessage || 'Price not available';
                throw new Error(error);
              });
          })
          .catch(error => {
            module.classList.remove('is-loading');
            module.innerHTML = resourceErrorMessage || 'Price not available';
            throw new Error(error);
          });
      } else {
        const splittedStaffels = staffels.split('#');
        splittedStaffels.sort((a, b) => a - b);

        const priceApiCalls = [];
        splittedStaffels.forEach(staffel => {
          priceApiCalls.push(this.getPrice(productId, staffel));
        });

        Promise.all(priceApiCalls)
          .then(responses => {
            const staffelPrices = responses.map((response, index) => {
              let { prices } = response._embedded;
              const { quantity } = response;
              let quantityText = `${quantity} +`;

              if (index < responses.length - 1)
                quantityText = `${quantity} - ${responses[index + 1].quantity - 1}`;

              prices = prices.length ? prices[0] : null;
              return { ...prices, quantity, quantityText, productId };
            });

            // filter staffelPrices with currentPrice already on other staffelPrices except the first one
            const filteredStaffelPrices = staffelPrices.filter((staffelPrice, i) => {
              if (i === 0) return true;
              return !staffelPrices.find(
                price =>
                  price.quantity !== staffelPrice.quantity &&
                  price.currentPrice === staffelPrice.currentPrice
              );
            });

            const lowestPriceEntry = filteredStaffelPrices.reduce((minEntry, price) => {
              const { currentPriceInclVat } = price;
              if (currentPriceInclVat < minEntry.currentPriceInclVat) return price;
              return minEntry;
            }, filteredStaffelPrices[0]);

            const templateView = 'RealTimePrice';
            const viewData = {
              price: lowestPriceEntry,
              hasChildren,
              pricesExTax,
              priceFrom: true,
              orderUnit
            };

            // create view based on template file
            jsonToView(viewData, templateView)
              .then(html => {
                module.classList.remove('is-loading');
                module.innerHTML = html;
              })
              .catch(error => {
                module.classList.remove('is-loading');
                module.innerHTML = resourceErrorMessage || 'Price not available';
                throw new Error(error);
              });
          })
          .catch(error => {
            module.classList.remove('is-loading');
            module.innerHTML = resourceErrorMessage || 'Price not available';
            throw new Error(error);
          });
      }
    });

    moduleListStaffel().forEach(module => this.initRealTimePriceStaffel(module));
  }
}

export default RealTimePrice;
